import React from "react";
import PropTypes from "prop-types";

import { Graphics } from "./components/Graphics";

import "./style.scss";

export class Light extends React.Component {
  componentWillMount() {
    this.props.createLight({
      props: this.props.defaultProps,
    });
  }

  render() {
    return (
      <ul>
        <li
          id={"Light_"+this.props.id}
          tabIndex={0}
          className={'Light'}>
          <Graphics id={this.props.id} />
        </li>
      </ul>
    );
  }
}

Light.propTypes = {
  createLight: PropTypes.func,
};

Light.defaultProps = {};
